import { isAddress } from 'web3-utils'

import { isENSDomain } from '../../../lib/ens'

export const isValidEthAddress = (address: string, ensSupport: boolean = false): boolean => {
  return isAddress(address) || (ensSupport && isENSDomain(address))
}
